// extracted by mini-css-extract-plugin
export default {"departments":"QG-z","departmentHeading":"RG-z","departmentSection":"SG-z","departmentName":"TG-z","departmentLink":"UG-z","expandIcon":"VG-z"};